module.exports = __webpack_public_path__ + "img/coupon_flower_outline.c9a052c0.png";